import React from "react";

import { Grid, Typography } from "@mui/material";

import {
  StandardPriceRange,
  StandardTextField,
} from "../../../components/standard-form-fields";

export default () => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6">
        委託 - 影片製作者（Vtuber、直播主、影片剪輯、動畫製作 等等）
      </Typography>
    </Grid>
    <StandardTextField
      name="video.style"
      required
      label="影片風格"
      placeholder="溫文、活潑、豪放等"
      registerProps={{
        required: "請填寫您的影片風格",
      }}
    />
    <StandardTextField
      name="video.genre"
      required
      label="擅長內容"
      placeholder="與觀眾互動、ASMR、唱歌等"
      registerProps={{
        required: "請填寫您的擅長內容",
      }}
    />
    <StandardTextField
      name="video.video_length"
      required
      label="平常的直播/影片時長"
      placeholder="以單段影片計算"
      registerProps={{
        required: "請填寫您平常的影片時長",
      }}
    />
    <StandardPriceRange
      name="video.price"
      required
      label="商業委託價格範圍"
      registerProps={{
        required: "請提供您可接受的委託價格",
      }}
    />
    <StandardTextField
      name="video.priceDetails"
      required
      label="商業委託價格詳情"
      placeholder="請註明委託內容及對應的價格（如: 一幅插畫單位角色含背景 2000 HKD 或 三萬字漫畫故事劇本 30000 NTD）"
      registerProps={{
        required: "請提供委託內容及對應的價格",
      }}
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="video.additionalInfo"
      label="補充說明"
      placeholder="如有任何特別技能、接案經驗或委託相關的注意事項，歡迎在此註明"
      textFieldProps={{
        multiline: true,
        minRows: 5,
      }}
    />
    <StandardTextField
      name="video.referenceLink"
      required
      label="直播頻道 / 精華片段"
      placeholder="直播頻道 / 精華片段連結"
      registerProps={{
        required: "請提供作品樣本供客戶參考",
      }}
    />
  </>
);
